import { Controller } from "@hotwired/stimulus"
import { loadRybbit, unloadRybbit } from "../lib/rybbit"
import { nativeAnalyticsAction } from "../lib/native_analytics"

// App native : pas de bandeau cookies, le consentement à la mesure d'usage est la case du
// setup et du profil (UserConsent kind analytics). Le serveur rend ce controller avec l'état
// du consentement ; la décision est dans lib/native_analytics.js. Umami, exempté, n'en dépend
// pas ; ici on ne charge Rybbit qu'avec consentement et on le coupe après un retrait (art. 7.3 RGPD).
export default class extends Controller {
  static values = { granted: Boolean, rybbitSrc: String }

  connect() {
    if (document.documentElement.hasAttribute("data-turbo-preview")) return

    const action = nativeAnalyticsAction({
      granted: this.grantedValue,
      rybbitSrc: this.rybbitSrcValue
    })

    if (action === "load") loadRybbit(this.rybbitSrcValue)
    else unloadRybbit()
  }
}
